import _ from 'underscore';
import $ from 'jquery';
import { keepAliveInstance } from '@bingads-webui/keep-alive';
// import { versionCheckInstance } from '@bingads-webui-campaign/version-check';
import { setupClarity } from '@bingads-webui-universal/clarity';
import { PageReady } from '@bingads-webui/page-ready';
import { setupQualtricsWithData } from '@bingads-webui-campaign/qualtrics';
import { initPDL } from './omniture';
import { redirectToLogin, CLARITY_IDS, isTestEnvironment, TEST_CLARITY_IDS, isSignupRunningProxy } from './constants';
import { checkUserQueryParams, deleteQueryParam } from './query-param-checker';

const isTestEnv = isTestEnvironment(document.domain);

export function setupServiceRoots(serverContext) {
  // we check for proxy running so that we can properly route cc API calls in proxy
  if (isSignupRunningProxy()) {
    // eslint-disable-next-line no-param-reassign
    serverContext.ServicesEndpoints.ClientCenterUIAPI = 'https://app1.ads-int.microsoft.com:12000/cc/';
  }
}

function getCLarityID(feature) {
  return isTestEnv ? TEST_CLARITY_IDS[feature] : CLARITY_IDS[feature];
}

/**
 * Initialize global app services.
 * @param {any} {
 *     featureName - Name of feature
 *     serverContext - Context needed for initializing libraries
 *     shouldLoadAdobe - Determines if Adobe tracking should load.
 *     shouldStartKeepAlive - Determines if keep-alive polling should start.
 *     shouldSetQueryParams - Determines if script to update url with query params will run
 *     shouldSetupQualtrics - Determines if qualtrics initialization should run.
 *     shouldEnableUnAuth - Determines if should not redirect when un auth
 *     shouldLoadAmplifyTracking - Determines if Amplify tracking script should load.
 *   }
 * @returns {void}
 */
export function initGlobalService({
  featureName,
  serverContext,
  shouldLoadAdobe = false,
  shouldStartKeepAlive = true,
  shouldSetQueryParams = false,
  shouldSetupQualtrics = false,
  shouldEnableUnAuth = false,
  shouldLoadAmplifyTracking = false,
}) {
  try {
    // remove skipcccache from URL, this should only be used once to refresh sever cache
    deleteQueryParam('skipcccache');

    if (!shouldEnableUnAuth) {
      // create callback that will sign out if user's auth token is invalid or expired
      keepAliveInstance.unAuthCallBack = () => redirectToLogin(serverContext);
    }

    if (shouldStartKeepAlive) {
      // start keep alive
      keepAliveInstance.start();
    }

    /*
    TODO: implement
    // start version check
    versionCheckInstance.version = serverContext.Version;
    versionCheckInstance.start();
    */

    if (shouldLoadAdobe) {
      // load perf mark
      const trackingScriptUrl = _.chain(serverContext)
        .result('ThirdPartConfig')
        .result('AdobeTrackingScriptUrl', undefined)
        .value();
      if (!_.isUndefined(trackingScriptUrl) && _.isFunction($.getScript)) {
        $.getScript(trackingScriptUrl, () => initPDL(serverContext));
      }
    }

    if (shouldLoadAmplifyTracking) {
      // load perf mark
      const amplifyTrackingScriptUrl = _.chain(serverContext)
        .result('AmplifyTrackingScriptUrl', undefined)
        .value();
      if (!_.isUndefined(amplifyTrackingScriptUrl) && _.isFunction($.getScript)) {
        $.getScript(amplifyTrackingScriptUrl);
      }
    }

    if (shouldSetQueryParams) {
      // if user put wrong values for known query params (uid, cid, aid)
      // restores it per server context
      checkUserQueryParams(serverContext);
    }

    // init an empty function to avoid customer click the help icon
    // before the apex loading is ready
    window.PopupController = { PopupJsClick: () => { } };
    PageReady.afterPageReady().then(() => {
      if (shouldSetupQualtrics) {
        setupQualtricsWithData(serverContext);
      }

      const clarityId = getCLarityID(featureName);

      if (clarityId) {
        const currentUserId = (serverContext.CurrentUser &&
          serverContext.CurrentUser.Id &&
          serverContext.CurrentUser.Id.toString()) || '';
        const customerId = (serverContext.CurrentCustomer &&
          serverContext.CurrentCustomer.Id &&
          serverContext.CurrentCustomer.Id.toString()) || '';
        const accountId = (serverContext.CurrentAccount &&
          serverContext.CurrentAccount.Id &&
          serverContext.CurrentAccount.Id.toString()) || '';

        setupClarity(
          clarityId,
          {
            customerId,
            accountId,
            SessionId: serverContext.Omniture.SessionId,
            PageTrackingId: serverContext.PageTrackingId,
            subFeature: featureName,
          },
          currentUserId,
          serverContext.Omniture.SessionId,
          serverContext.PageTrackingId
        );
      } else {
        // eslint-disable-next-line no-console
        console.error('init global service error');
      }
    });

    setupServiceRoots(serverContext);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`init global service raise exception ${e}`);
  }
}
